import { ViewConnector } from "./ViewConnector";

/** An enum representing all possible steps within any Flow. */
export enum Step {
  qualify = 2,
  medicalGeneral = 3,
  medicalPacemaker = 4,
  medicalRadiation = 5,
  medicalDiabetic = 6,
  centerSelection = 7,
  scheduling = 8
}

/** A map between the step and the uri path it is located at. */
export const StepPathMap: Record<Step, string> = {
  [Step.centerSelection]: "centerSelection",
  [Step.medicalGeneral]: "medical/1",
  [Step.medicalPacemaker]: "medical/2",
  [Step.medicalRadiation]: "medical/3",
  [Step.medicalDiabetic]: "medical/4",
  [Step.qualify]: "qualify",
  [Step.scheduling]: "scheduling"
};

/** The properties that all views are universally provided with.  */
export interface StepProps {
  /** @see {@link ViewConnector} */
  viewConnector: ViewConnector;
}

/** Returns the uri path to the given step and flow. */
export const GetStepPath = (step?: Step) => `/app${step ? `/${StepPathMap[step]}` : ""}`;

/** Discover the current step by matching from the current uri path.
 * @param currentPathName - The current uri path.
 */
export const GetCurrentStep = (currentPathName: string): Step | undefined => {
  const stepPathKeyValuePair = Object.entries(StepPathMap).find(([, pathName]) => currentPathName.includes(pathName));
  return stepPathKeyValuePair && (Number(stepPathKeyValuePair[0]) as Step);
};
